import React, { useEffect, useState } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const AlertSwal = withReactContent(Swal);

const TestForm = () => {
    const [level, setLevel] = useState('EMT');
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [result, setResult] = useState(null);

    const user = JSON.parse(localStorage.getItem('ems_member'))?.user;

    useEffect(() => {
        if (!level) return;
        setLoading(true);
        fetch(`https://ems.lexikonn.eu/api/get_test.php?level=${level}`)
            .then(res => res.json())
            .then(data => {
                setQuestions(data);
                setAnswers({});
                setSubmitted(false);
                setResult(null);
                setLoading(false);
            });
    }, [level]);

    const handleAnswer = (qid, answer) => {
        setAnswers(prev => ({ ...prev, [qid]: answer }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const totalQuestions = questions.length;
        const answered = Object.keys(answers).length;

        if (answered < totalQuestions) {
            AlertSwal.fire({
                icon: 'warning',
                title: 'Neodpověděl jsi na všechny otázky!',
                text: `Zodpovězeno pouze ${answered} z ${totalQuestions} otázek.`,
                confirmButtonColor: '#dc3545'
            });
            return;
        }

        const payload = {
            user_id: user.nickname,
            test_level: level,
            answers: answers
        };

        const res = await fetch('https://ems.lexikonn.eu/api/submit_test.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const data = await res.json();
        setResult(data);
        setSubmitted(true);
    };


    return (
        <div className="container py-5">
            <h2 className="mb-4">🧪 EMS Test</h2>

            <Form.Group className="mb-4">
                <Form.Label>Vyber úroveň testu</Form.Label>
                <Form.Select value={level} onChange={(e) => setLevel(e.target.value)}>
                    <option value="EMT">EMT</option>
                    <option value="Paramedic">Paramedic</option>
                    <option value="Doctor">Doctor</option>
                </Form.Select>
            </Form.Group>

            {loading ? (
                <Spinner animation="border" />
            ) : submitted && result ? (
                <Alert variant={result.result === 'passed' ? 'success' : 'danger'}>
                    <h4>{result.result === 'passed' ? '✅ Úspěšně složeno!' : '❌ Test nesplněn'}</h4>
                    <p>Výsledek: {result.score}% správných odpovědí</p>
                </Alert>
            ) : (
                <Form onSubmit={handleSubmit}>
                    {questions.map((q, idx) => (
                        <Form.Group className="mb-4" key={q.id}>
                            <Form.Label><b>{idx + 1}. {q.question}</b></Form.Label>
                            {q.options.map((opt, i) => (
                                <Form.Check
                                    key={i}
                                    type="radio"
                                    name={`question-${q.id}`}
                                    label={opt}
                                    value={opt.charAt(0)}
                                    checked={answers[q.id] === opt.charAt(0)}
                                    onChange={() => handleAnswer(q.id, opt.charAt(0))}
                                />
                            ))}
                        </Form.Group>
                    ))}
                    <Button variant="danger" type="submit">Odeslat test</Button>
                </Form>
            )}
        </div>
    );
};

export default TestForm;
